module.exports = __webpack_public_path__ + "img/icon-weixinx.8518e494.png";